"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeContentContribution = void 0;
const react_1 = __importDefault(require("react"));
const inversify_1 = require("inversify");
const home_component_1 = __importDefault(require("../components/home/home-component"));
let HomeContentContribution = class HomeContentContribution {
    getContent(authContext) {
        return react_1.default.createElement(home_component_1.default, null);
    }
    getDocumentProvider() {
        return (_context) => {
            const canonicalBaseUrl = this.resolveCanonicalBaseUrl();
            const canonicalUrl = canonicalBaseUrl;
            const document = {
                title: 'Authlance — Authentication, Licensing & Billing for Software Companies. Stop building auth. Start shipping your product.',
                meta: [
                    {
                        attributes: {
                            name: 'description',
                            content: 'Authlance unifies the business side of your product — no external platforms, no fragile integrations, just your stack running on your infrastructure.',
                        },
                    },
                    {
                        attributes: {
                            name: 'keywords',
                            content: 'Authlance, authentication, access control, multi-tenant, licensing, subscriptions.',
                        },
                    },
                    {
                        attributes: {
                            property: 'og:title',
                            content: 'Authlance — Authentication, Licensing & Billing for Software Companies',
                        },
                    },
                    {
                        attributes: {
                            property: 'og:description',
                            content: 'Authlance unifies the business side of your product — no external platforms, no fragile integrations, just your stack running on your infrastructure.',
                        },
                    },
                    {
                        attributes: {
                            property: 'og:type',
                            content: 'website',
                        },
                    },
                    {
                        attributes: {
                            property: 'og:url',
                            content: canonicalUrl,
                        },
                    },
                    {
                        attributes: {
                            name: 'twitter:card',
                            content: 'summary',
                        },
                    },
                    {
                        attributes: {
                            name: 'twitter:title',
                            content: 'Authlance — Authentication, Licensing & Billing',
                        },
                    },
                    {
                        attributes: {
                            name: 'twitter:description',
                            content: 'Authlance unifies the business side of your product — no external platforms, no fragile integrations, just your stack running on your infrastructure.',
                        },
                    },
                    {
                        attributes: {
                            name: 'twitter:url',
                            content: canonicalUrl,
                        },
                    },
                ],
                links: [
                    {
                        attributes: {
                            rel: 'canonical',
                            href: canonicalUrl,
                        },
                    },
                ],
            };
            return Promise.resolve(document);
        };
    }
    resolveCanonicalBaseUrl() {
        var _a;
        const env = typeof process !== 'undefined' ? (_a = process.env) !== null && _a !== void 0 ? _a : {} : {};
        const raw = (typeof env.AUTHLANCE_PUBLIC_URL === 'string' && env.AUTHLANCE_PUBLIC_URL.trim()) ||
            (typeof env.ROOT_APP_URL === 'string' && env.ROOT_APP_URL.trim()) ||
            (typeof env.APP_URL === 'string' && env.APP_URL.trim()) ||
            'https://authlance.com';
        return raw.replace(/\/+$/, '') || 'https://authlance.com';
    }
    getWeight() {
        return 100;
    }
};
exports.HomeContentContribution = HomeContentContribution;
exports.HomeContentContribution = HomeContentContribution = __decorate([
    (0, inversify_1.injectable)()
], HomeContentContribution);
